import { BaseEntity } from '../../models';
import { Pais } from '../pais';

export class Estado implements BaseEntity {
    id: number;
    uf: string;
    nome: string;
    codigoIbge: number;
    idPais: number;
    pais: Pais;
    inscricaoEstadualMascara: string;
    possuiInscricaoSuframa: boolean;

    constructor(props: Partial<Estado>) {
        Object.assign(this, props);
    }
}
